import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Portfolio.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { portfolioProjects, publicSrc } from '../data/portfolioProjects';

const Portfolio = () => {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      offset: 100,
      easing: 'ease-out',
    });
  }, []);

  return (
    <div className="portfolio-page">
      <div className="portfolio-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content" data-aos="fade-up">
          <h1 className="gradient-text">OUR PROJECTS</h1>
          <p>Explore our featured work in metal fabrication and installation</p>
        </div>
      </div>
      <div className="portfolio-main">
        <div className="portfolio-intro-block">
          <p className="portfolio-scope-lede" data-aos="fade-up">
            Advanced Metal Shop fabricates and installs miscellaneous metals and structural steel on
            site, from tender through shop production and field erection. Work is built and fitted per
            the contract drawing package and specifications from the project design team on transit,
            institutional, and commercial jobs, coordinated with your schedule and site access.
          </p>
        </div>
        <div className="portfolio-gallery-grid">
          {portfolioProjects.map((project, idx) => (
            <div
              key={project.id}
              className="portfolio-gallery-card"
              onClick={() => navigate(`/projects/${project.id}`)}
              tabIndex={0}
              role="button"
              onKeyPress={(e) => {
                if (e.key === 'Enter') navigate(`/projects/${project.id}`);
              }}
              data-aos="fade-up"
              data-aos-delay={30 + idx * 40}
            >
              <img
                src={publicSrc(project.mainImage)}
                alt={project.title}
                className="portfolio-gallery-img"
              />
              <div className="portfolio-gallery-info">
                <h2>{project.title}</h2>
                <p>{project.description}</p>
              </div>
            </div>
          ))}
        </div>
        <p
          className="portfolio-gallery-note portfolio-gallery-note--below"
          role="note"
          data-aos="fade-up"
        >
          Note: Thumbnail and project photos are representative. A large share of structural and
          miscellaneous metal at each site is covered after completion by finishes, fireproofing,
          ceilings, walls, and other built-up work. Additional miscellaneous scope was supplied and
          installed beyond what appears in the images.
        </p>
      </div>
      <div className="portfolio-cta" data-aos="fade-up">
        <h2>Ready to start your project?</h2>
        <p>Let&apos;s discuss how we can bring your vision to life</p>
        <Link to="/contact" className="cta-button">
          Get in touch
        </Link>
      </div>
    </div>
  );
};

export default Portfolio;
